import { useCallback, useState } from 'react';

const storageKey = (employeeId: string) => `dismissed-schedule-alerts:${employeeId}`;

const readDismissedIds = (employeeId?: string): Set<string> => {
  if (!employeeId) return new Set();
  try {
    const raw = localStorage.getItem(storageKey(employeeId));
    return raw ? new Set(JSON.parse(raw) as string[]) : new Set();
  } catch {
    return new Set();
  }
};

export const useDismissedScheduleAlerts = (employeeId?: string) => {
  const [dismissedIds, setDismissedIds] = useState<Set<string>>(() => readDismissedIds(employeeId));

  const dismiss = useCallback(
    (requestId: string) => {
      if (!employeeId) return;
      setDismissedIds(current => {
        const next = new Set(current);
        next.add(requestId);
        try {
          localStorage.setItem(storageKey(employeeId), JSON.stringify(Array.from(next)));
        } catch (ex) {
          // storage full/unavailable - dismissal still works for this session via state,
          // just won't persist across reloads
          console.log(ex);
        }
        return next;
      });
    },
    [employeeId]
  );

  const isDismissed = useCallback((requestId: string) => dismissedIds.has(requestId), [dismissedIds]);

  return { isDismissed, dismiss };
};
